var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighRise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0, 0, 0, 0.5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 30.954V27a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3.954H1a1 1 0 0 1-1-1V1.753a1 1 0 0 1 1-1h13.456a1 1 0 0 1 1 1v28.2a1 1 0 0 1-1 1H10zM3 8.214h9a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2zm0 5h9a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2zm0 5h9a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2zm0 5h9a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2zM18.117.981l3.813.45a1 1 0 0 1 .883.993v27.132a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1V1.975A1 1 0 0 1 18.117.98zM19 8.213h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2zm0 5h2a1 1 0 1 0 0-2h-2a1 1 0 0 0 0 2zm0 5h2a1 1 0 1 0 0-2h-2a1 1 0 0 0 0 2zm0 5h2a1 1 0 1 0 0-2h-2a1 1 0 0 0 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRise);
export default __webpack_public_path__ + "static/media/high-rise.ee97486bbaac439a9ea77c69bc883d09.svg";
export { ForwardRef as ReactComponent };